module.exports = __webpack_public_path__ + "static/media/pawritten-bold.0d53d7fb.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/pawritten-bold.woff2
// module id = ./src/assets/fonts/pawritten-bold.woff2
// module chunks = 6